module.exports = __webpack_public_path__ + "images/p-value1-08.webp";